import { ProgressBar } from '@/features/ProgressBar/ui/ProgresBar'
import { ShortedTypography } from '@/shared/ui/ShortedTypography'
import {
    convertDurationToMinutes,
    getPcLevelIcon,
    getStringFromGenresArray,
} from '@/shared/lib'
import { Box, Typography } from '@mui/material'
import React from 'react'
import VodDetails from '@/features/VOD/vodClasses/vodDetails'

interface Props {
    details: VodDetails | null
}

const HoverItemDetails = ({ details }: Props) => {
    if (!details) return <></>
    const progressBarStyle = {
        position: 'absolute',
        bottom: '14px',
        left: '15%',
        width: '70%',
    }
    const { duration, genres, pcLevel, description } = details
    return (
        <Box padding="10px" position="relative" height="100%">
            <Box display="flex">
                <Box>{pcLevel ? getPcLevelIcon(pcLevel) : null}</Box>
                <Box padding="20px">
                    {duration && (
                        <Typography mb="6px">
                            {convertDurationToMinutes(duration)}
                        </Typography>
                    )}
                    {genres?.length !== 0 && (
                        <Typography>
                            {getStringFromGenresArray(genres)}
                        </Typography>
                    )}
                </Box>
            </Box>
            {description ? (
                <ShortedTypography mb="45px">
                    {description.length < 200
                        ? description
                        : `${description.slice(0, 250)} ${
                              description.length > 100 ? '...' : ''
                          }`}
                </ShortedTypography>
            ) : null}

            <Box sx={progressBarStyle}>
                <ProgressBar min={1} max={100} value={10} width={100} />
            </Box>
        </Box>
    )
}

export default HoverItemDetails
